<div class="text-title" *ngIf="!isUserOn7DayFreeTrialVersion && !hideTitle">
    How should Rosie answer calls?
</div>
<div class="text-description">
    You can forward calls from your existing business number to your agent's number directly, or a combination of both.
</div>
<div class="setup-item choose-calls-setup-section my-4">
    <div class="call-option-section" [ngClass]="{'selected': isCallForwardingSelected}"
        (click)="setActiveCallForwardingOption(true)">
        <ng-icon class="icon" [name]="'heroPhoneArrowUpRightSolid'"
            [color]="isCallForwardingSelected ? '#822AC6' : '#9487A0'" [size]="'20px'"></ng-icon>
        <div class="title">Forward Calls</div>
        <div class="description">Send calls from your existing number to Rosie.</div>
    </div>
    <div class="call-option-section" [ngClass]="{'selected': !isCallForwardingSelected}"
        (click)="setActiveCallForwardingOption(false)">
        <img class="icon"
            [src]="isCallForwardingSelected ? 'assets/images/rosie-call.svg' : 'assets/images/rosie-call-selected.svg'">
        <div class="title">Use Rosie Number</div>
        <div class="description">Share the agent's number as your new business line.</div>
    </div>
</div>
<ng-container *ngIf="isCallForwardingSelected; else useRosieNumber">
    <div class="setup-item">
        <div class="setup-item-label">Phone System Type</div>
        <div class="setup-form w-100">
            <rosie-select-input [control]="phoneSystemTypeControl" [options]="phoneSystemTypeOptions"
                [placeholderTranslationKey]="'Select Type'" [dataHook]="'phone-system-type'">
            </rosie-select-input>
        </div>
    </div>
    <div class="setup-item">
        <div class="setup-item-label">Select Your Provider</div>
        <div class="setup-form w-100">
            <rosie-select-input [control]="providerControl" [options]="providerOptions"
                [disabled]="!phoneSystemTypeControl.value" [placeholderTranslationKey]="'Select Provider'"
                [dataHook]="'phone-provider'">
            </rosie-select-input>
        </div>
    </div>
    <div *ngIf="currentInstructions" class="setup-item mb-0" [@fadeInUp]>
        <div class="phone-forwarding-wrapper">
            <div class="instructions-section mt-4">
                <div class="instructions-content-wrapper">
                    <div class="provider-instructions">
                        <h4>Forwarding Instructions</h4>
                        <h5 class="selected-provider-name">{{ selectedProvider?.name }}</h5>
                        <div class="instructions-content" [innerHTML]="currentInstructions"></div>
                        <div *ngIf="currentNotes?.length > 0 && selectedSystemType?.id === 'voip'">
                            <h5>Notes:</h5>
                            <ul>
                                <li *ngFor="let note of currentNotes">{{ note }}</li>
                            </ul>
                        </div>
                        <div class="detailed-instructions-link">
                            <rosie-button [customClass]="'transparent primary'" class="w-100 d-block"
                                (click)="openInstructions()" [translationKey]="'Detailed Instructions'"
                                [iconSuffixConfig]="{name: 'heroArrowUpRight', color: '#822ac6', size: '20px', strokeWidth: '2'}">
                            </rosie-button>
                        </div>
                    </div>
                    <div *ngIf="currentNotes?.length > 0 && selectedSystemType?.id !== 'voip'" class="notes-section">
                        <h5>Notes:</h5>
                        <ul>
                            <li *ngFor="let note of currentNotes">{{ note }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!currentInstructions" class="setup-item mb-0" [@fadeInUp]>
        <div class="phone-forwarding-not-selected">
            <img class="special-arrow" [src]="'assets/images/special-arrow-up.svg'">
            Select your phone system type & provider
        </div>
    </div>
</ng-container>
<ng-template #useRosieNumber>
    <rosie-number (requestLocalAreaCodeClicked)="onRequestLocalAreaCodeClicked()"></rosie-number>
</ng-template>